import React from 'react';
import { Link } from "react-router-dom";
import logo from '../../assets/images/libcloud_logo.svg'
import { footerLinks1, navlinks } from '../../constant.js';

const Footer = () => {
    return (
        <div>
            <style>
                {`
                .social_links {
                display: flex;
                // gap: 10px;
                margin: 15px 0 0 0;
                padding: 0;
                }
                ul li {
    list-style: none;
}

.social_links li a {
    overflow: hidden;
    position: relative;
    width: 42px;
    height: 42px;
    background-color: transparent;
    display: flex;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    z-index: 1;
}
    .social_links li a .icon {
    position: relative;
    color: #fff;
}

.footer-gradient {
    background: linear-gradient(
        90deg,
        #3478f6 0%,
        #8b45c8 50%,
        #ec1687 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;
}
                `}
            </style>
            <div className='sizedbox row g-2 gap-2 py-5 justify-content-between' style={{ backgroundColor: "#2f244f" }}>
                <div className='col-12 col-md-6'>
                    <Link to="/">
                        <img src={logo} alt="Libcloud" style={{ backgroundColor: "#fff", borderRadius: "10px" }}></img>
                    </Link>
                    <p className="mt-4" style={{ fontSize: "18px", fontWeight: "400", lineHeight: "24px", color: "#FEFEFF" }}>
                        LibCloud is your reliable partner for managing Koha Library Management Software and its mobile application. We specialize in expert setup and cloud-based support for Koha—a powerful and sophisticated library management system.
                    </p>
                    {/* <ul className="social_links">
                        {
                            social_media.map((item, index) => (
                                <li>
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ '--hover-color': item.color }} >
                                        <span className="icon">{item.icon}</span></a>
                                </li>
                            ))
                        }
                    </ul> */}
                </div>
                <div className='col-12 col-md-5'>
                    <div className="d-flex gap-5">
                        <div>
                            <h3 className="footer-gradient" style={{ fontSize: "24px", fontWeight: "500", lineHeight: "30px" }}>LibCloud</h3>
                            {
                                <ul className="left-links m-0 p-0">
                                    {footerLinks1.map((item, index) => (
                                        <li className=" mt-3">
                                            <Link className="text-decoration-none" style={{ fontSize: "16px", fontWeight: "500", color: "#FEFEFF" }} to={item.path}>{item.title}</Link>
                                        </li>
                                    ))}
                                </ul>
                            }
                        </div>
                        <div>
                            <h3 className="footer-gradient" style={{ fontSize: "24px", fontWeight: "500", lineHeight: "30px" }}>Services</h3>
                             {
                                <ul className="right-links m-0 p-0">
                                    {navlinks[1].subMenu.map((item, index) => (
                                        <li className=" mt-3">
                                            <Link className="text-decoration-none" style={{ fontSize: "16px", fontWeight: "500", color: "#FEFEFF" }} to={item.path}>{item.title}</Link>
                                        </li>
                                    ))}
                                </ul>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <div className='py-1 text-center align-items-center bg-white'>
                <p style={{ fontSize: "16px", fontWeight: "500", color: "var(--text-color)", marginBottom: "0" }} >All rights reserved @Libcloud.in</p>
            </div>
        </div>
    );
}

export default Footer;
